/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CoinDtoPaginationResultDto } from '../models/CoinDtoPaginationResultDto';
import type { CoinMarketCapCategoryDto } from '../models/CoinMarketCapCategoryDto';
import type { FavoriteCoinsDto } from '../models/FavoriteCoinsDto';
import type { CancelablePromise } from '../../../core/CancelablePromise';
import type { BaseHttpRequest } from '../../../core/BaseHttpRequest';
export class CoinsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param category
     * @param page
     * @param count
     * @param orderBy
     * @param inverseOrder
     * @returns CoinDtoPaginationResultDto Success
     * @throws ApiError
     */
    public getV1Coins(
        category?: string,
        page: number = 1,
        count: number = 100,
        orderBy: string = 'MarketCap',
        inverseOrder: boolean = true,
    ): CancelablePromise<CoinDtoPaginationResultDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/coins',
            query: {
                'category': category,
                'page': page,
                'count': count,
                'orderBy': orderBy,
                'inverseOrder': inverseOrder,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns FavoriteCoinsDto Success
     * @throws ApiError
     */
    public getV1CoinsFavorites(): CancelablePromise<FavoriteCoinsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/coins/favorites',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param coin
     * @returns any Created
     * @throws ApiError
     */
    public postV1CoinsFavorites(
        coin: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v1/coins/favorites/{coin}',
            path: {
                'coin': coin,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param coin
     * @returns void
     * @throws ApiError
     */
    public deleteV1CoinsFavorites(
        coin: string,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/v1/coins/favorites/{coin}',
            path: {
                'coin': coin,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
    }
    /**
     * @param isConfiguredInCrm
     * @returns CoinMarketCapCategoryDto Success
     * @throws ApiError
     */
    public getV1CoinsCategories(
        isConfiguredInCrm: boolean = false,
    ): CancelablePromise<Array<CoinMarketCapCategoryDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v1/coins/categories',
            query: {
                'isConfiguredInCrm': isConfiguredInCrm,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
